<script>
	import {Form} from '../../helpers/Form/Form'

	export default {
		data() {
			return {
				purchaseElement: null,
				form: new Form({
					phone: null
				})
			}
		},
		mounted() {
			this.$bus.$on('opt-signature.show', (payload) => {
				this.$set(this, 'purchaseElement', payload.purchaseElement)
				$("#moduleOtpSignature").modal('show')
			})

			$("#moduleOtpSignature").on('hidden.bs.modal', () => {
				this.$set(this, 'purchaseElement', null)
				this.form.reset()
			})
		},
		methods: {
			onSubmit() {
				let data = this.form.data()

				this.form
					.submit('post', route('module.otp', this.purchaseElement.id))
					.then(response => {
						$("#moduleOtpSignature").modal('hide')

						this.$bus.$emit('otp-sent', data)
					})
			}
		}
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/purchases/VoucherPartecipantsModuleRequestOtp.vue